import React, { useState, useEffect } from "react";
import Header from "./Comman/Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LuUser, LuMail, LuLock } from "react-icons/lu";


export default function VerifyEmail() {

  const username = localStorage.getItem("username");
  const [data, setdata] = useState([]);
  const navigate = useNavigate();
  const [contactNo, setContactNo] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);


  const getData = async () => {
    if (!username) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        username,
        key: process.env.REACT_APP_KEY,
      });

      if (res.data?.error || !res.data?.data) {
        setdata(null);
      } else {
        setdata(res.data.data);
      }

    } catch (error) {
      console.error("Profile fetch error:", error);
      setdata(null);
    } finally {
      setLoading(false); // ✅ ALWAYS stop loader
    }
  };

  useEffect(() => {
    getData();
  }, [username]);


  const updateContact = async (e) => {
    e.preventDefault();

    if (!contactNo) {
      alert("Enter  Email");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactNo)) {
      alert("Enter a valid email address");
      return;
    }

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "send",
        email: contactNo,
        password: password,
        username: username,
        key: process.env.REACT_APP_KEY,
      });
      console.log('res.data', res.data);

      if (res.data.resCode === 200) {
        alert(res.message || "OTP Send To Your Email!");
        navigate("/verify2")
        localStorage.setItem("email", contactNo);
      } else {
        alert(res.data.message || "Error updating Email");
      }
    } catch (error) {
      alert(error.response?.data?.message || "Server Error");
    }
  };

  //   useEffect(() => {
  //   if (data) {

  //     setLoading(false); // stop loading when data is ready
  //   }
  // }, [data]);

  const customStyles = `
    .db-profile-card {
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.03);
      border: 1px solid rgba(0, 0, 0, 0.05);
      position: relative;
      overflow: hidden;
    }

    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 16px; 
      padding: 16px 20px; 
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      position: relative;
      transition: all 0.3s;
      margin-bottom: 24px;
    }
    .db-input-wrapper:focus-within {
       border-color: #006fe3;
    }
    .db-input {
      background: transparent; border: none; outline: none; width: 100%; font-weight: 500; color: #1e293b; font-size: 16px;
    }
    .db-input:focus, .db-input:active {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
      background: transparent;
    }
    
    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; border: none; padding: 16px; border-radius: 14px;
      font-weight: 700; width: 100%; font-size: 16px; 
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.4); transition: 0.3s;
      display: flex; align-items: center; justify-content: center; gap: 8px;
    }
    .db-modern-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0, 111, 227, 0.5); }
    .db-modern-btn.cancel {
      background: #f8fafc;
      color: #1e293b;
      border: 1px solid #e2e8f0;
      box-shadow: 0 4px 6px rgba(0,0,0,0.02);
    }
    .db-modern-btn.cancel:hover {
      background: #e2e8f0;
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />

        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-5 col-md-8 col-12">
                <div className="db-profile-card p-4">

                  {/* Heading */}
                  <div className="text-center mb-4">
                    <div style={{ width: 60, height: 60, borderRadius: '50%', background: 'rgba(0, 111, 227, 0.1)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#006fe3', border: '1px solid rgba(0, 111, 227, 0.2)' }}>

                      <span className="db-input-icon-box icon-slate">
                        <LuUser size={20} />
                      </span>
                    </div>
                    <h3 className="text-dark fw-bold mt-3 mb-1">Verify Your Email</h3>
                    <p className="text-black small">Enter your email and current password</p>
                  </div>

                  {loading ? (
                    <div className="text-center py-4 text-black">
                      <div className="spinner-border spinner-border-sm me-2"></div> Loading...
                    </div>
                  ) : (
                    <form onSubmit={updateContact}>

                      <label className="text-black small fw-bold ms-1 mb-1">Username</label>
                      <div className="db-input-wrapper" style={{ background: '#f8fafc', boxShadow: 'none' }}>
                        <span className="db-input-icon-box icon-cyan">
                          <LuUser size={20} />
                        </span>
                        <input className="db-input text-black" style={{ border: "none", outline: "none", boxShadow: "none", color: "#000" }} value={username || ''} disabled />
                      </div>

                      <label className="text-black small fw-bold ms-1 mb-1">Email</label>
                      <div className="db-input-wrapper">
                        <span className="db-input-icon-box icon-cyan">
                          <LuMail size={20} />
                        </span>
                        <input
                          className="db-input text-black"
                          style={{ border: "none", outline: "none", boxShadow: "none", color: "#000" }}
                          type="text"
                          placeholder="Your Email"
                          value={contactNo}
                          onChange={(e) => setContactNo(e.target.value)}
                          required
                        />
                      </div>

                      <label className="text-black small fw-bold ms-1 mb-1">Password</label>
                      <div className="db-input-wrapper">
                        <span className="db-input-icon-box icon-cyan">
                          <LuLock size={20} />
                        </span>
                        <input
                          className="db-input text-black"
                          style={{ border: "none", outline: "none", boxShadow: "none", color: "#000" }}
                          type="password"
                          placeholder="Current Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>

                      <div className="d-flex gap-3 mt-4">
                        <button
                          type="button"
                          className="db-modern-btn cancel"
                          onClick={() => {
                            setContactNo("");
                            navigate("/profile");
                          }}
                        >
                          Cancel
                        </button>

                        <button type="submit" className="db-modern-btn">
                          Send OTP
                        </button>
                      </div>

                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section >
      </div >
    </>
  );
}
